export default __webpack_public_path__ + "static/media/profile.417f58f2.png";